import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'

import { withStyles, makeStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const customStyles = theme => ({
    customInput: {
        backgroundColor: '#ffffff !important',
        boxShadow: '0 2px 2px -1px rgba(0,0,0,.2), 0 2px 3px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)',
        borderRadius: '0',
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1976d2',
        },
    },
    customLabel: {
        '&.Mui-focused': {
            color: '#1976d2 !important'
        }
    }
})
// const CustomOutlinedInput = withStyles(customStyles)(OutlinedInput);


class DropdownFilterMenu extends Component {
    constructor() {
        super();
        this.labelRef = React.createRef();
    }
    render() {
        const labelWidth = this.labelRef.current ? this.labelRef.current.clientWidth : 0;

        return (
            <FormControl
                
                variant="outlined"
                className="dropdown-filter-menu"
            >
                <InputLabel ref={this.labelRef} className={this.props.classes.customLabel} shrink htmlFor="dropdown-select">
                    {this.props.label}
                </InputLabel>
                <Select
                    value={this.props.value}
                    onChange={this.props.onChange}
                    input={<OutlinedInput className={this.props.classes.customInput} labelWidth={labelWidth} id="dropdown-select" />}
                >
                    {this.props.choices.map(choice=>(
                        <MenuItem value={choice.value}>
                            {choice.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

        )
    }
}

export default withStyles(customStyles)(DropdownFilterMenu);